module.exports = __webpack_public_path__ + "media/images/help/about/eyecatch-staff-7b31b03e13dca9596c8361bd116ee88d.png";